/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root";
import { Route as VersionRouteImport } from "./routes/version";
import { Route as SummaryRouteImport } from "./routes/summary";
import { Route as SettingsRouteImport } from "./routes/settings";
import { Route as ResetRouteImport } from "./routes/reset";
import { Route as TrainRouteRouteImport } from "./routes/train/route";
import { Route as ProdRouteRouteImport } from "./routes/prod/route";
import { Route as OmoRouteRouteImport } from "./routes/omo/route";
import { Route as IndexRouteImport } from "./routes/index";
import { Route as TrainResultsRouteImport } from "./routes/train/results";
import { Route as TrainExerciseRouteImport } from "./routes/train/exercise";
import { Route as ProdResultsRouteImport } from "./routes/prod/results";
import { Route as ProdExerciseRouteImport } from "./routes/prod/exercise";
import { Route as OmoResultsRouteImport } from "./routes/omo/results";
import { Route as OmoExerciseRouteImport } from "./routes/omo/exercise";

const VersionRoute = VersionRouteImport.update({
  id: "/version",
  path: "/version",
  getParentRoute: () => rootRouteImport,
} as any);
const SummaryRoute = SummaryRouteImport.update({
  id: "/summary",
  path: "/summary",
  getParentRoute: () => rootRouteImport,
} as any);
const SettingsRoute = SettingsRouteImport.update({
  id: "/settings",
  path: "/settings",
  getParentRoute: () => rootRouteImport,
} as any);
const ResetRoute = ResetRouteImport.update({
  id: "/reset",
  path: "/reset",
  getParentRoute: () => rootRouteImport,
} as any);
const TrainRouteRoute = TrainRouteRouteImport.update({
  id: "/train",
  path: "/train",
  getParentRoute: () => rootRouteImport,
} as any);
const ProdRouteRoute = ProdRouteRouteImport.update({
  id: "/prod",
  path: "/prod",
  getParentRoute: () => rootRouteImport,
} as any);
const OmoRouteRoute = OmoRouteRouteImport.update({
  id: "/omo",
  path: "/omo",
  getParentRoute: () => rootRouteImport,
} as any);
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any);
const TrainResultsRoute = TrainResultsRouteImport.update({
  id: "/results",
  path: "/results",
  getParentRoute: () => TrainRouteRoute,
} as any);
const TrainExerciseRoute = TrainExerciseRouteImport.update({
  id: "/exercise",
  path: "/exercise",
  getParentRoute: () => TrainRouteRoute,
} as any);
const ProdResultsRoute = ProdResultsRouteImport.update({
  id: "/results",
  path: "/results",
  getParentRoute: () => ProdRouteRoute,
} as any);
const ProdExerciseRoute = ProdExerciseRouteImport.update({
  id: "/exercise",
  path: "/exercise",
  getParentRoute: () => ProdRouteRoute,
} as any);
const OmoResultsRoute = OmoResultsRouteImport.update({
  id: "/results",
  path: "/results",
  getParentRoute: () => OmoRouteRoute,
} as any);
const OmoExerciseRoute = OmoExerciseRouteImport.update({
  id: "/exercise",
  path: "/exercise",
  getParentRoute: () => OmoRouteRoute,
} as any);

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute;
  "/omo": typeof OmoRouteRouteWithChildren;
  "/prod": typeof ProdRouteRouteWithChildren;
  "/train": typeof TrainRouteRouteWithChildren;
  "/reset": typeof ResetRoute;
  "/settings": typeof SettingsRoute;
  "/summary": typeof SummaryRoute;
  "/version": typeof VersionRoute;
  "/omo/exercise": typeof OmoExerciseRoute;
  "/omo/results": typeof OmoResultsRoute;
  "/prod/exercise": typeof ProdExerciseRoute;
  "/prod/results": typeof ProdResultsRoute;
  "/train/exercise": typeof TrainExerciseRoute;
  "/train/results": typeof TrainResultsRoute;
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute;
  "/omo": typeof OmoRouteRouteWithChildren;
  "/prod": typeof ProdRouteRouteWithChildren;
  "/train": typeof TrainRouteRouteWithChildren;
  "/reset": typeof ResetRoute;
  "/settings": typeof SettingsRoute;
  "/summary": typeof SummaryRoute;
  "/version": typeof VersionRoute;
  "/omo/exercise": typeof OmoExerciseRoute;
  "/omo/results": typeof OmoResultsRoute;
  "/prod/exercise": typeof ProdExerciseRoute;
  "/prod/results": typeof ProdResultsRoute;
  "/train/exercise": typeof TrainExerciseRoute;
  "/train/results": typeof TrainResultsRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/": typeof IndexRoute;
  "/omo": typeof OmoRouteRouteWithChildren;
  "/prod": typeof ProdRouteRouteWithChildren;
  "/train": typeof TrainRouteRouteWithChildren;
  "/reset": typeof ResetRoute;
  "/settings": typeof SettingsRoute;
  "/summary": typeof SummaryRoute;
  "/version": typeof VersionRoute;
  "/omo/exercise": typeof OmoExerciseRoute;
  "/omo/results": typeof OmoResultsRoute;
  "/prod/exercise": typeof ProdExerciseRoute;
  "/prod/results": typeof ProdResultsRoute;
  "/train/exercise": typeof TrainExerciseRoute;
  "/train/results": typeof TrainResultsRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/omo"
    | "/prod"
    | "/train"
    | "/reset"
    | "/settings"
    | "/summary"
    | "/version"
    | "/omo/exercise"
    | "/omo/results"
    | "/prod/exercise"
    | "/prod/results"
    | "/train/exercise"
    | "/train/results";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/"
    | "/omo"
    | "/prod"
    | "/train"
    | "/reset"
    | "/settings"
    | "/summary"
    | "/version"
    | "/omo/exercise"
    | "/omo/results"
    | "/prod/exercise"
    | "/prod/results"
    | "/train/exercise"
    | "/train/results";
  id:
    | "__root__"
    | "/"
    | "/omo"
    | "/prod"
    | "/train"
    | "/reset"
    | "/settings"
    | "/summary"
    | "/version"
    | "/omo/exercise"
    | "/omo/results"
    | "/prod/exercise"
    | "/prod/results"
    | "/train/exercise"
    | "/train/results";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  OmoRouteRoute: typeof OmoRouteRouteWithChildren;
  ProdRouteRoute: typeof ProdRouteRouteWithChildren;
  TrainRouteRoute: typeof TrainRouteRouteWithChildren;
  ResetRoute: typeof ResetRoute;
  SettingsRoute: typeof SettingsRoute;
  SummaryRoute: typeof SummaryRoute;
  VersionRoute: typeof VersionRoute;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/version": {
      id: "/version";
      path: "/version";
      fullPath: "/version";
      preLoaderRoute: typeof VersionRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/summary": {
      id: "/summary";
      path: "/summary";
      fullPath: "/summary";
      preLoaderRoute: typeof SummaryRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings": {
      id: "/settings";
      path: "/settings";
      fullPath: "/settings";
      preLoaderRoute: typeof SettingsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/reset": {
      id: "/reset";
      path: "/reset";
      fullPath: "/reset";
      preLoaderRoute: typeof ResetRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/train": {
      id: "/train";
      path: "/train";
      fullPath: "/train";
      preLoaderRoute: typeof TrainRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/prod": {
      id: "/prod";
      path: "/prod";
      fullPath: "/prod";
      preLoaderRoute: typeof ProdRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/omo": {
      id: "/omo";
      path: "/omo";
      fullPath: "/omo";
      preLoaderRoute: typeof OmoRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/": {
      id: "/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/train/results": {
      id: "/train/results";
      path: "/results";
      fullPath: "/train/results";
      preLoaderRoute: typeof TrainResultsRouteImport;
      parentRoute: typeof TrainRouteRoute;
    };
    "/train/exercise": {
      id: "/train/exercise";
      path: "/exercise";
      fullPath: "/train/exercise";
      preLoaderRoute: typeof TrainExerciseRouteImport;
      parentRoute: typeof TrainRouteRoute;
    };
    "/prod/results": {
      id: "/prod/results";
      path: "/results";
      fullPath: "/prod/results";
      preLoaderRoute: typeof ProdResultsRouteImport;
      parentRoute: typeof ProdRouteRoute;
    };
    "/prod/exercise": {
      id: "/prod/exercise";
      path: "/exercise";
      fullPath: "/prod/exercise";
      preLoaderRoute: typeof ProdExerciseRouteImport;
      parentRoute: typeof ProdRouteRoute;
    };
    "/omo/results": {
      id: "/omo/results";
      path: "/results";
      fullPath: "/omo/results";
      preLoaderRoute: typeof OmoResultsRouteImport;
      parentRoute: typeof OmoRouteRoute;
    };
    "/omo/exercise": {
      id: "/omo/exercise";
      path: "/exercise";
      fullPath: "/omo/exercise";
      preLoaderRoute: typeof OmoExerciseRouteImport;
      parentRoute: typeof OmoRouteRoute;
    };
  }
}

interface OmoRouteRouteChildren {
  OmoExerciseRoute: typeof OmoExerciseRoute;
  OmoResultsRoute: typeof OmoResultsRoute;
}

const OmoRouteRouteChildren: OmoRouteRouteChildren = {
  OmoExerciseRoute: OmoExerciseRoute,
  OmoResultsRoute: OmoResultsRoute,
};

const OmoRouteRouteWithChildren = OmoRouteRoute._addFileChildren(
  OmoRouteRouteChildren,
);

interface ProdRouteRouteChildren {
  ProdExerciseRoute: typeof ProdExerciseRoute;
  ProdResultsRoute: typeof ProdResultsRoute;
}

const ProdRouteRouteChildren: ProdRouteRouteChildren = {
  ProdExerciseRoute: ProdExerciseRoute,
  ProdResultsRoute: ProdResultsRoute,
};

const ProdRouteRouteWithChildren = ProdRouteRoute._addFileChildren(
  ProdRouteRouteChildren,
);

interface TrainRouteRouteChildren {
  TrainExerciseRoute: typeof TrainExerciseRoute;
  TrainResultsRoute: typeof TrainResultsRoute;
}

const TrainRouteRouteChildren: TrainRouteRouteChildren = {
  TrainExerciseRoute: TrainExerciseRoute,
  TrainResultsRoute: TrainResultsRoute,
};

const TrainRouteRouteWithChildren = TrainRouteRoute._addFileChildren(
  TrainRouteRouteChildren,
);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  OmoRouteRoute: OmoRouteRouteWithChildren,
  ProdRouteRoute: ProdRouteRouteWithChildren,
  TrainRouteRoute: TrainRouteRouteWithChildren,
  ResetRoute: ResetRoute,
  SettingsRoute: SettingsRoute,
  SummaryRoute: SummaryRoute,
  VersionRoute: VersionRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
